module.exports = __webpack_public_path__ + "img/lr.cf309785.svg";